import { z } from 'zod/v4'

export const userRelationValidation = () => {
  return z.object({
    group: z.string().min(1, { message: 'Form is required' }),
    related_id: z.string().min(1, { message: 'Form is required' }),
  })
}